import { types } from "../types/types";

export const uiOpenModalOrdersOrDeliverys = (data) => ({
    type: types.uiOpenModalOrdersOrDeliverys,
    payload: data
});

export const uiCloseModalOrdersOrDeliverys = () => ({
    type: types.uiCloseModalOrdersOrDeliverys
});